import React from 'react';
import ReactCountryFlag from "react-country-flag";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line } from 'recharts';

const ChartComponent = (props) => {

  const transformData = () => {
    const { labels, datasets } = props.data;
    return labels.map((label, index) => {
      
      const item = { name: label };
      datasets.forEach(dataset => {
        item[dataset.label || 'value'] = dataset.data[index];
      });
      return item;
    });
  };

  const colors = [
    '#1890FF', '#f95d6a', '#ffc658', '#82ca9d', '#a4de6c',
    '#d0ed57', '#ff8042', '#83a6ed', '#ff6e7f', '#a05195',
    '#d45087', '#8dd1e1', '#ff7c43', '#665191', '#a05195',
    '#003f5c', '#2f4b7c', '#665191', '#a05195', '#d45087'
  ];

  const chartData = transformData();

  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US').format(value);
  };

  const CustomTooltipPerforment = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{
          backgroundColor: '#fff',
          padding: '12px',
          border: '1px solid #ccc',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'grid', gap: '4px' }}>
            <p>{label}</p>
            {payload.map((entry, index) => (
              <div key={`item-${index}`} style={{
                color: entry.color,
                display: 'flex',
                alignItems: 'center'
              }}>
                <span className='me-2'>
                  {entry.name} :
                </span>
                <b>{formatNumber(entry.value)}</b>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{
          backgroundColor: '#fff',
          padding: '12px',
          border: '1px solid #ccc',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'grid', gap: '4px' }}>
            {payload.map((entry, index) => (
              <div key={`item-${index}`} style={{
                color: entry.color,
                display: 'flex',
                alignItems: 'center'
              }}>
                {
                  props.options?.flag && 
                  <>
                    <span className='me-2'>
                      <ReactCountryFlag countryCode={label} svg />
                    </span>
                  </>
                }
                <span className='me-2'>
                  {label} :
                </span>
                <b>{formatNumber(entry.value)}</b>
              </div>
            ))}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={props.height || 400}>
      <BarChart
        data={chartData}
        layout={props.options?.indexAxis === 'y' ? 'vertical' : 'horizontal'}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        {props.options?.indexAxis === 'y' ? (
          <>
            <XAxis type="number" tickFormatter={formatNumber} />
            <YAxis dataKey="name" type="category" />
          </>
        ) : (
          <>
            <XAxis dataKey="name" />
            <YAxis 
              yAxisId="left" 
              orientation="left" 
              tickFormatter={formatNumber} 
            />
            {props.options?.multi && (
              <YAxis 
                yAxisId="right" 
                orientation="right" 
                tickFormatter={formatNumber} 
              />
            )}
          </>
        )}

        {
          props.options?.multi ? 
          <Tooltip content={CustomTooltipPerforment} />
          :
          <Tooltip content={CustomTooltip} />
        }
        
        {
          props.options.legend && <Legend />
        }
        {props.options?.multi ? (
          <>
            {props.data.datasets.slice(0, 1).map((dataset, index) => (
              <Bar
                key={`bar-${index}`}
                dataKey={dataset.label || 'value'}
                fill={colors[index % colors.length]}
                barSize={dataset.barThickness || 20}
                yAxisId="left"
                activeBar={false} 
              />
            ))}
            
            {props.data.datasets.slice(1, 3).map((dataset, index) => (
              <Line
                key={`line-${index}`}
                type="monotone"
                dataKey={dataset.label || 'value'}
                stroke={colors[(index + 1) % colors.length]}
                strokeWidth={2}
                dot={false}
                activeDot={{ 
                  r: 6, 
                  strokeWidth: 2,
                  stroke: '#fff',
                  fill: colors[(index + 1) % colors.length]
                }} 
                yAxisId="right"
              />
            ))}
          </>
        ) : (
          <>
            {props.data.datasets.map((dataset, index) => (
              <Bar
                key={index}
                dataKey={dataset.label || 'value'}
                fill={colors[index % colors.length]}
                barSize={dataset.barThickness || 20}
              />
            ))}
          </>
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChartComponent;